module.exports = __webpack_public_path__ + "static/media/MarvinVisionsTrial-Variable.ce847b0d.ttf";